import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ShareModal = ({ gallery, onClose }) => {
  const [copied, setCopied] = useState(false);
  const shareLink = `https://radiavision.gallery/view/${gallery?.shareCode}`;

  const handleCopyLink = () => {
    navigator.clipboard?.writeText(shareLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleShareEmail = () => {
    const subject = encodeURIComponent(`View Gallery: ${gallery?.name}`);
    const body = encodeURIComponent(`Hi,\n\nI'd like to share my gallery "${gallery?.name}" with you.\n\nView it here: ${shareLink}\n\nBest regards`);
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-xl w-full max-w-md shadow-warm-xl">
        <div className="flex items-center justify-between p-4 md:p-6 border-b border-border">
          <h2 className="text-xl font-semibold">Share Gallery</h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted smooth-transition"
            aria-label="Close modal"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-4 md:p-6 space-y-6">
          <div>
            <h3 className="text-lg font-medium mb-2">{gallery?.name}</h3>
            <p className="text-sm text-muted-foreground">{gallery?.description}</p>
          </div>

          <div className="bg-muted rounded-lg p-4 space-y-3">
            <div className="flex items-center gap-2 text-sm">
              <Icon name="Link" size={16} color="var(--color-primary)" />
              <span className="font-medium">Shareable Link</span>
            </div>
            <div className="flex gap-2">
              <Input
                type="text"
                value={shareLink}
                readOnly
                className="flex-1"
              />
              <Button
                variant={copied ? 'success' : 'default'}
                size="default"
                iconName={copied ? 'Check' : 'Copy'}
                onClick={handleCopyLink}
              >
                {copied ? 'Copied' : 'Copy'}
              </Button>
            </div>
          </div>

          <div className="space-y-3">
            <p className="text-sm font-medium">Share via</p>
            <div className="grid grid-cols-2 gap-3">
              <Button
                variant="outline"
                iconName="Mail"
                iconPosition="left"
                onClick={handleShareEmail}
                fullWidth
              >
                Email
              </Button>
              <Button
                variant="outline"
                iconName="MessageSquare"
                iconPosition="left"
                onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(shareLink)}`, '_blank')}
                fullWidth
              >
                WhatsApp
              </Button>
            </div>
          </div>

          <div className="bg-accent/10 border border-accent/20 rounded-lg p-4">
            <div className="flex gap-3">
              <Icon name="Info" size={20} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
              <div className="text-sm">
                <p className="font-medium text-accent mb-1">Gallery Access</p>
                <p className="text-muted-foreground">
                  Visitors will need to authenticate with their name, email, and phone number to access this gallery.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex gap-3 p-4 md:p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
            fullWidth
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;